/**
 * @ngdoc service
 * @name mx.shell.KeyboardNavigationService
 * @module mx.shell
 *
 * @description Provides registring/unregistring hotkeys functionality
 */

MxKeyboardNavigationService.$inject = ['hotkeys'];

export function MxKeyboardNavigationService(hotkeys) {
	var service = {
		registerKey: registerKey,
		unregisterKey: unregisterKey,
		listKeys: listKeys,
		getKeyOptions: getKeyOptions,
	};

	var registeredKeys = {};

	return service;

	function getKeyOptions(key) {
		return registeredKeys[key];
	}

	function registerKey(options) {
		var isMultipleKeys = Array.isArray(options);

		if (isMultipleKeys) {
			validateOptions(options);
			applyKeys(options);
		} else {
			validateOption(options);
			applyKey(options);
		}

		function applyKeys(options) {
			options.forEach(function (option) {
				applyKey(option);
			});
		}

		function applyKey(options) {
			var key = options.key;
			var description = options.description || 'No description';
			var callback = options.callback;
			var scope = options.scope;
			var nameInTemplate = options.nameInTemplate;
			var onRegister = options.onRegister;
			var hint = options.hint;

			registeredKeys[key] = options;

			if (onRegister) {
				onRegister();
			}

			if (scope) {
				if (nameInTemplate) {
					if (hint) {
						scope[nameInTemplate] = hint;
					} else {
						scope[nameInTemplate] = key.split('+').slice(1).join('+');
					}
				}

				scope.$on('$destroy', function () {
					delete registeredKeys[key];
				});

				hotkeys.bindTo(scope).add({
					combo: key,
					description: description,
					callback: callback,
					allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				});
			} else {
				hotkeys.add({
					combo: key,
					description: description,
					callback: callback,
					allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				});
			}
		}
	}

	function unregisterKey(key) {
		if (!key) {
			throw new Error('No hotkey to remove provided.');
		}

		hotkeys.del(key);
		delete registeredKeys[key];
	}

	function listKeys() {
		return Object.keys(registeredKeys);
	}

	function validateOptions(options) {
		options.forEach(function (option) {
			validateOption(option);
		});
	}

	function validateOption(option) {
		if (!option) {
			throw new Error('No options object provided.');
		}

		if (!option.key) {
			throw new Error('No hotkey to add provided.');
		}

		if (!option.callback) {
			throw new Error('No callback for a hotkey provided.');
		}

		// If (registeredKeys[option.key]) {
		// 	Throw new Error('Key already registered.');
		// }
	}
}
